/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type OutreachCuraiRedirectContentActionTaken =
  | (typeof OutreachCuraiRedirectContentActionTaken)[keyof typeof OutreachCuraiRedirectContentActionTaken]
  | null;

export const OutreachCuraiRedirectContentActionTaken = {
  visit_started: "visit_started",
  visit_updated: "visit_updated",
} as const;
